import { IonCol, IonGrid, IonRow, isPlatform } from "@ionic/react";
import {
  Autocomplete,
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  SelectChangeEvent,
  TextField,
} from "@mui/material";
import React, {
  ChangeEvent,
  forwardRef,
  ReactNode,
  SetStateAction,
  useEffect,
  useImperativeHandle,
  useMemo,
  useRef,
  useState,
} from "react";
import { GenerateGUID } from "../components/Common";

import api from "./../services/api";

// import { v4 as uuidv4, v4 } from "uuid";

type Props = {
  setIssueType?: React.Dispatch<React.SetStateAction<string>>;
  setIssueTypes?: React.Dispatch<React.SetStateAction<string[]>>;
  issueType: string | string[];
  options: string[];
  multiple?: boolean;
};

const IssueTypeSelect: React.FC<Props> = ({
  setIssueType,
  setIssueTypes,
  issueType,
  options,
  multiple = false,
}) => {
  const [open, setOpen] = React.useState(false);

  const handleChange = (event: SelectChangeEvent<typeof issueType>) => {
    const {
      target: { value },
    } = event;
    if (setIssueType) {
      const val = value as string | null;
      setIssueType(val ?? "");
    }
    if (setIssueTypes) {
      const val = value as string[] | null;
      setIssueTypes(val ?? []);
    }
  };

  const loading = open && options.length === 0;

  return (
    <FormControl sx={{ width: "100%" }}>
      <InputLabel id="issue-type-select">Typ zgłoszenia</InputLabel>
      <Select
        labelId="issue-type-select"
        input={<OutlinedInput label="Typ zgłoszenia" />}
        multiple={multiple}
        sx={{
          width: {
            xs: "100%",
            sm: "100%",
            md: "auto",
          },
        }}
        open={open}
        onOpen={() => {
          setOpen(true);
        }}
        onClose={() => {
          setOpen(false);
        }}
        onChange={handleChange}
        value={setIssueType ? (issueType as string) : (issueType as string[])}
      >
        {options.map((e) => {
          return (
            <MenuItem key={e} value={e}>
              {e}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};

export default IssueTypeSelect;
